// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables independent of screen size */
:root {
  /* Official BSA Color Palette */
  --scouting-america-red: #CE1126FF;
  --scouting-america-blue: #003F87FF;
  --scouting-america-tan: #D6CEBDFF;
  --scouting-america-grey: #515254FF;
  --scouting-america-white: #E7EDF6FF;
  --scouting-america-black: #010A14FF;
  --scouting-america-pale-blue: #9AB3D5FF;
  --scouting-america-dark-blue: #003366FF;
  --scouting-america-light-tan: #E9E9E4FF;
  --scouting-america-dark-tan: #AD9D&BFF;
  --scouting-america-pale-grey: #858787FF;
  --scouting-america-dark-grey: #232528FF;

  /* Font families */
  --font-1: -apple-system, BlinkMacSystemFont,
    'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetica Neue', sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


/* Laptop (and Lerger Screen) Variables */
@media (min-width: 1021px) {
  :root {
    /* Font sizing */
    --header-font-size:    34px;
    --subheader-font-size: 24px;

    --body-big-size:    20px;
    --body-normal-size: 18px;
    --body-small-size:  14px;

    --font-bold: 500;
    --font-bolder: 700;

    --body-line-height: 1.5;
  }

  .bsat312-body {
    padding-left: 20px;
    padding-right: 20px;
    
    margin-top: 150px;
    margin-bottom: 20px;
  }
}

/* Tablet Variables */
@media (min-width: 751px) and (max-width: 1020px) {
  :root {
    /* Font sizing */
    --header-font-size:    30px;
    --subheader-font-size: 20px;

    --body-big-size:    18px;
    --body-normal-size: 16px;
    --body-small-size:  14px;

    --font-bold: 500;
    --font-bolder: 700;

    --body-line-height: 1.5;
  }

  .bsat312-body {
    padding-left: 25px;
    padding-right: 25px;

    margin-top: 150px;
    margin-bottom: 20px;
  }
}

/* Mobile (Landscape) Variables */
@media (min-width: 451px) and (max-width: 750px) {
  :root {
    /* Font sizing */
    --header-font-size:    24px;
    --subheader-font-size: 20px;

    --body-big-size:    16px;
    --body-normal-size: 14px;
    --body-small-size:  12px;

    --font-bold: 500;
    --font-bolder: 700;

    --body-line-height: 1.5;
  }

  .bsat312-body {
    padding-left: 20px;
    padding-right: 20px;

    margin-top: 150px;
    margin-bottom: 20px;
  }
}

/* Mobile (Portrait) Variables */
@media (max-width: 450px) {
  :root {
    /* Font sizing */
    --header-font-size:    20px;
    --subheader-font-size: 16px;

    --body-big-size:    16px;
    --body-normal-size: 14px;
    --body-small-size:  10px;

    --font-bold: 500;
    --font-bolder: 700;

    --body-line-height: 1.5;
  }

  .bsat312-body {
    padding-left: 15px;
    padding-right: 15px;

    margin-top: 70px;
    margin-bottom: 20px;
  }
}




* {
  box-sizing: border-box;
}

body {
  background-color: var(--scouting-america-black);
  color: var(--scouting-america-white);

  margin: 0;
  
  font-family: var(--font-1);
  line-height: var(--body-line-height);
}

.bsat312-container {
  background-color: var(--scouting-america-black);

  min-height: 100vh;

  display: flex;
  flex-direction: column;
}

.bsat312-body {
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  display: flex;
  flex: 1 1;
  flex-direction: column;
}

.bsat312-body h1 {
  color: var(--scouting-america-white);

  margin-bottom: 10px;
}

.bsat312-body p {
  color: var(--scouting-america-white);
}

/* Skip to main content link for screen readers */
.skip-to-main {
  position: absolute;
  top: -40px;
  left: 0;
  background: var(--scouting-america-red);
  color: var(--scouting-america-white);
  padding: 8px;
  text-decoration: none;
  z-index: 10000;
  font-weight: 700;
}

.skip-to-main:focus {
  top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;;EAEvC,kBAAkB;EAClB;;;gCAG8B;;EAE9B,mCAAmC;EACnC,kCAAkC;AACpC;;;AAGA,yCAAyC;AACzC;EACE;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;;IAE3B,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,gBAAgB;IAChB,kBAAkB;;IAElB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;;IAEnB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;;IAE3B,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,gBAAgB;IAChB,kBAAkB;;IAElB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;;IAEnB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;;IAE3B,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,gBAAgB;IAChB,kBAAkB;;IAElB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;;IAEnB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;;IAE3B,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,gBAAgB;IAChB,kBAAkB;;IAElB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;;IAEnB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;;;;AAKA;EACE,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;;EAEpC,SAAS;;EAET,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;;EAE/C,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;;EAElB,aAAa;EACb,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;;EAEpC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,uCAAuC;EACvC,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR","sourcesContent":["/* Global variables independent of screen size */\n:root {\n  /* Official BSA Color Palette */\n  --scouting-america-red: #CE1126FF;\n  --scouting-america-blue: #003F87FF;\n  --scouting-america-tan: #D6CEBDFF;\n  --scouting-america-grey: #515254FF;\n  --scouting-america-white: #E7EDF6FF;\n  --scouting-america-black: #010A14FF;\n  --scouting-america-pale-blue: #9AB3D5FF;\n  --scouting-america-dark-blue: #003366FF;\n  --scouting-america-light-tan: #E9E9E4FF;\n  --scouting-america-dark-tan: #AD9D&BFF;\n  --scouting-america-pale-grey: #858787FF;\n  --scouting-america-dark-grey: #232528FF;\n\n  /* Font families */\n  --font-1: -apple-system, BlinkMacSystemFont,\n    'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',\n    'Cantarell', 'Fira Sans', 'Droid Sans',\n    'Helvetica Neue', sans-serif;\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n\n/* Laptop (and Lerger Screen) Variables */\n@media (min-width: 1021px) {\n  :root {\n    /* Font sizing */\n    --header-font-size:    34px;\n    --subheader-font-size: 24px;\n\n    --body-big-size:    20px;\n    --body-normal-size: 18px;\n    --body-small-size:  14px;\n\n    --font-bold: 500;\n    --font-bolder: 700;\n\n    --body-line-height: 1.5;\n  }\n\n  .bsat312-body {\n    padding-left: 20px;\n    padding-right: 20px;\n    \n    margin-top: 150px;\n    margin-bottom: 20px;\n  }\n}\n\n/* Tablet Variables */\n@media (min-width: 751px) and (max-width: 1020px) {\n  :root {\n    /* Font sizing */\n    --header-font-size:    30px;\n    --subheader-font-size: 20px;\n\n    --body-big-size:    18px;\n    --body-normal-size: 16px;\n    --body-small-size:  14px;\n\n    --font-bold: 500;\n    --font-bolder: 700;\n\n    --body-line-height: 1.5;\n  }\n\n  .bsat312-body {\n    padding-left: 25px;\n    padding-right: 25px;\n\n    margin-top: 150px;\n    margin-bottom: 20px;\n  }\n}\n\n/* Mobile (Landscape) Variables */\n@media (min-width: 451px) and (max-width: 750px) {\n  :root {\n    /* Font sizing */\n    --header-font-size:    24px;\n    --subheader-font-size: 20px;\n\n    --body-big-size:    16px;\n    --body-normal-size: 14px;\n    --body-small-size:  12px;\n\n    --font-bold: 500;\n    --font-bolder: 700;\n\n    --body-line-height: 1.5;\n  }\n\n  .bsat312-body {\n    padding-left: 20px;\n    padding-right: 20px;\n\n    margin-top: 150px;\n    margin-bottom: 20px;\n  }\n}\n\n/* Mobile (Portrait) Variables */\n@media (max-width: 450px) {\n  :root {\n    /* Font sizing */\n    --header-font-size:    20px;\n    --subheader-font-size: 16px;\n\n    --body-big-size:    16px;\n    --body-normal-size: 14px;\n    --body-small-size:  10px;\n\n    --font-bold: 500;\n    --font-bolder: 700;\n\n    --body-line-height: 1.5;\n  }\n\n  .bsat312-body {\n    padding-left: 15px;\n    padding-right: 15px;\n\n    margin-top: 70px;\n    margin-bottom: 20px;\n  }\n}\n\n\n\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  background-color: var(--scouting-america-black);\n  color: var(--scouting-america-white);\n\n  margin: 0;\n  \n  font-family: var(--font-1);\n  line-height: var(--body-line-height);\n}\n\n.bsat312-container {\n  background-color: var(--scouting-america-black);\n\n  min-height: 100vh;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.bsat312-body {\n  max-width: 1400px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n\n.bsat312-body h1 {\n  color: var(--scouting-america-white);\n\n  margin-bottom: 10px;\n}\n\n.bsat312-body p {\n  color: var(--scouting-america-white);\n}\n\n/* Skip to main content link for screen readers */\n.skip-to-main {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background: var(--scouting-america-red);\n  color: var(--scouting-america-white);\n  padding: 8px;\n  text-decoration: none;\n  z-index: 10000;\n  font-weight: 700;\n}\n\n.skip-to-main:focus {\n  top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
